import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-calculator-icon',
  templateUrl: './shopping-calculator.component.html'
})
export class ShoppingCalculatorComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
